const subscriptions = {};

const buildUrl = studyIds => {
  const params = new URLSearchParams();
  studyIds.filter(Boolean).forEach(studyId => params.append("study", studyId));
  return `/api/discussions/events/?${params.toString()}`;
};

export function openDiscussionEvents(studyIds, { onSnapshot, onUnreadChanged, onError }) {
  if (typeof EventSource === "undefined") {
    return null;
  }
  const key = studyIds.filter(Boolean).join(",");
  if (!key) {
    return null;
  }
  if (subscriptions[key]) {
    return subscriptions[key];
  }

  const source = new EventSource(buildUrl(studyIds));
  const close = () => {
    source.close();
    delete subscriptions[key];
  };

  source.addEventListener("discussion.snapshot", event => {
    if (onSnapshot) {
      onSnapshot(JSON.parse(event.data));
    }
  });
  source.addEventListener("discussion.unread_changed", event => {
    if (onUnreadChanged) {
      onUnreadChanged(JSON.parse(event.data));
    }
  });
  source.onerror = event => {
    if (onError) {
      onError(event);
    }
  };

  subscriptions[key] = { close, source };
  return subscriptions[key];
}
